import { createEvent, restore } from 'effector'
import { ActiveBalanceFilter } from './types'

export const setActiveBalanceFilter = createEvent<ActiveBalanceFilter>()

export const $activeBalanceFilter = restore(setActiveBalanceFilter, {
  activeBalanceCountries: [],
  paymentSystem: '',
})
